<!----------------------- Компонент відновлення пароля --------------------->
<template>
  <div id="loginContainerBox" class="forgot-password-page">
    <div class="forgot-password-form">
      <!-- <headloginreg /> -->
      <div class="header-login">
        <headloginreg />
        <!-- Мова -->
        <div class="langSelector">
          <LangSelectComponent @changeLang="changeLang($event)" />
        </div>
      </div>
      <div class="container">
        <h5 class="restore-password-title">{{ lang['RestorePassword'] }}</h5>
        <div class="forgot-password">
          <div class="enter-password">
            <label for="password">{{ lang['Password'] }}</label>
            <b-form-input autofocus type="password" name="password" id="newPass" :state="statePassword"
              v-model="form.password" />
            <span v-if="form.password.length > 0" @click="showPass"
              :class="visiblePass ? 'icon-eye' : 'icon-eye-blocked'"></span>
          </div>
          <div class="repeat-password">
            <label for="repeatpassword">{{ lang['RepeatPassword'] }}</label>
            <b-form-input type="password" name="repeat_password" id="rePass" :state="stateReeatPassword"
              v-model="form.repeatPassword" />
            <span v-if="form.repeatPassword.length > 0" @click="showRePass"
              :class="visibleRePass ? 'icon-eye' : 'icon-eye-blocked'"></span>
          </div>
          <button class="btn btn-success" @click="saveNewPassword">{{ lang['SaveNewPassword'] }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from "@/store.js"; // Глобальне сховище даних
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами
import headloginreg from './heads/HeaderLoginAndReg.vue'; // Компонент хедеру з логотипом
// import { store } from '@/store'
import { regAPi } from '../API.js'
import LangSelectComponent from './LangSelectComponent.vue';
const apiList = new regAPi();
export default {
  components: {
    headloginreg,
    LangSelectComponent
  },
  data() {
    return {
      form: {
        password: '',
        repeatPassword: '',
      },
      mailLang: '',
      visiblePass: false,
      visibleRePass: false
    }
  },
  mounted() {
    this.getUserLogin(); // Завантажуємо дані користувача
    keyevent.$off('enter'); //// Видаляємо попередню прив'язку до події "enter", щоб уникнути дублювання
    keyevent.$on('enter', () => this.saveNewPassword()); // Додаємо нову обробку події "enter" — при натисканні буде збережено новий пароль
  },
  methods: {
    // Зберегти новий пароль
    saveNewPassword() {
      // Перша перевірка необхідна якщо раптом користувач сам додав у рядку /forgotpassword
      if (this.getUserLogin().login != null && this.getUserLogin().pass_token != null) {
        if (this.statePassword && this.stateReeatPassword) {
          // Збираємо об'єкт з отриманих значень у засланні та введеного користувачем пароля
          const obj = {
            ...this.getUserLogin(),
            new_password: this.form.password
          }
          apiList.sendNewPassword(obj).then(resp => {
            if (resp.data.status == 'done') {
              window.say.message(this.lang['Saved'])
              this.$router.push('/');
            } else {
              window.say.messageError(this.lang['Error']);
            }
          })
          console.warn(obj)
        } else {
          window.say.messageError(this.lang['MinPassLength']);
        }
      } else {
        window.say.messageError(this.lang['LinkIsNotValid']);
      }
    },
    // Тут ми будемо діставати логін користувача з посилання
    getUserLogin() {
      const url = window.location.href;
      const personLogin = (new URL(url)).searchParams;

      this.mailLang = personLogin.get("lang")
      // Повертаємо об'єкт у якому поміщаємо видерті з посилання значення
      const obj = {
        login: personLogin.get("login"),
        pass_token: personLogin.get("pass_token")
      }
      return obj;
    },
    showPass() {
      this.visiblePass = !this.visiblePass
      const input = document.getElementById('newPass');
      if (input.getAttribute('type') == 'password') {
        input.setAttribute('type', 'text');
      } else {
        input.setAttribute('type', 'password');
      }
    },
    showRePass() {
      this.visibleRePass = !this.visibleRePass
      const input1 = document.getElementById('rePass');
      if (input1.getAttribute('type') == 'password') {
        input1.setAttribute('type', 'text');
      } else {
        input1.setAttribute('type', 'password');
      }
    },
    // Зміна мови
    changeLang(l) {
      localStorage.setItem("lang_user", l);
      store.lang = l;
      window.lang = store.langs[store.lang]();
    }
  },
  computed: {
    // Мова додатку
    lang() {
      return store.langs[store.lang]();
    },
    // Перевіряє, чи введений пароль має довжину 4 або більше символів
    statePassword() {
      return this.form.password.length >= 4 ? true : false;
    },
    // Перевіряє, чи поле повторення пароля заповнене і чи збігається з основним паролем
    stateReeatPassword() {
      return this.form.repeatPassword != '' && this.form.repeatPassword == this.form.password ? true : false;
    }
  }
}
</script>

<style scoped>
.forgot-password-page {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow-y: auto;
}

.forgot-password-form {
  margin: 15px 20px;
  width: 100%;
  background-color: white;
}

.container {
  padding: 0;
}

.forgot-password {
  padding: 0 !important;
}

.header-login {
  margin-bottom: 50px;
}

.restore-password-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
}

label::first-letter {
  text-transform: uppercase;
}

.enter-password,
.repeat-password {
  position: relative;
}

.icon-eye,
.icon-eye-blocked {
  position: absolute;
  right: 11.5%;
  top: 62.5%;
}

@media (min-width: 400px) and (max-width: 569.98px) {

  .icon-eye,
  .icon-eye-blocked {
    position: absolute;
    right: 10.5%;
    top: 62.5%;
  }
}

@media (min-width: 570px) and (max-width: 767.98px) {

  .icon-eye,
  .icon-eye-blocked {
    position: absolute;
    right: 7.5%;
    top: 62.5%;
  }
}


/* .icon-eye:before {
  content: "\e0c6";
}

.icon-eye-blocked:before {
  content: "\e0c7";
} */

@media screen and (min-width: 576px) {
  .forgot-password-form {
    max-width: 536px;
  }
}

@media screen and (min-width: 768px) {
  #loginContainerBox {
    background:
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' transform='rotate(-30 7 8)' viewBox='0 0 14 16' width='50'%3E%3Cpath fill='%23eee' d='M.377 13.484h8.466c1.374 0 1.439-1.092 1.439-1.596 0-.586-.152-1.257-1.483-1.655L2.776 8.41c-.239-.063-1.199-.377-1.81-1.091C.268 6.521.181 5.369.181 4.55c0-.881.109-1.95.981-2.727.785-.711 1.768-.818 2.51-.818h8.792v2.203H4.653c-.392 0-.851.021-1.199.336-.371.335-.392.859-.392 1.132 0 .651.196 1.279 1.417 1.657l5.585 1.699c1.024.315 1.724.63 2.181 1.048.917.839 1.004 2.141 1.004 2.831 0 .923-.131 1.952-.763 2.729-.764.943-1.724 1.047-2.727 1.047H.377v-2.203z'/%3E%3C/svg%3E"),
      linear-gradient(184deg, rgb(211, 211, 211) 0%, rgb(240, 240, 240) 80%);
    background-repeat: repeat;
    background-size: cover;
    background-position: center, center;
  }

  .forgot-password-form {
    max-width: 430px;
    padding: 30px;
    border-radius: 12px;
    background-color: white;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .forgot-password-page {
    align-items: center;
  }
}

@media screen and (min-width: 1200px) {
  .forgot-password-form {
    margin: 0;
  }

  .forgot-password-page {
    display: flex;
    align-items: center;
  }
}

.forgot-password {
  padding: 15px;
}

.form-control.is-valid,
.form-control.is-valid:focus {
  border-color: #00c279;
}

.form-control.is-valid {
  border-color: #00c279;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2300C279' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

.form-control.is-invalid,
.form-control.is-invalid:focus {
  border-color: #ff3548;
}

.form-control.is-invalid {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ff3548' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
}

.btn-success {
  width: 100%;
  background-color: #00C279;
  border: none;
}

.btn-success:not(:disabled):not(.disabled):active {
  background-color: #00B26F;
}

.btn-success:hover {
  background-color: #00B26F;
}
</style>